import { memo } from 'react';
import { SeparatorEl } from '../dropdown.styled';

export const Separator = memo(() => <SeparatorEl role="separator" />);
Separator.displayName = 'Dropdown.Separator';
